<template>
  <section class="text-gray-700">
    <div class="container px-5 py-8 mx-auto">
      <div class="mb-20 text-center">
        <h2 class="mb-4 text-2xl font-medium text-center text-gray-900 sm:text-3xl title-font">Faq</h2>
        <p
          class="mx-auto text-base leading-relaxed xl:w-2/4 lg:w-3/4"
        >Sprawdź co znajdzuję się w naszej ofercie</p>
      </div>
      <div class="flex flex-wrap -mx-2 lg:w-4/5 sm:mx-auto sm:mb-2">
        <div class="w-full px-4 py-2 lg:w-1/2">
          <details class="mb-4">
            <summary
              class="px-4 py-2 font-semibold bg-gray-200 rounded-md"
            >How Long is this site live?</summary>

            <span>
              Laboris qui labore cillum culpa in sunt quis sint veniam. Dolore ex aute
              deserunt esse ipsum elit aliqua. Aute quis minim velit nostrud pariatur culpa
              magna in aute.
            </span>
          </details>
          <details class="mb-4">
            <summary
              class="px-4 py-2 font-semibold bg-gray-200 rounded-md"
            >Can I install/upload anything I want on there?</summary>

            <span>
              Laboris qui labore cillum culpa in sunt quis sint veniam. Dolore ex aute
              deserunt esse ipsum elit aliqua. Aute quis minim velit nostrud pariatur culpa
              magna in aute.
            </span>
          </details>
          <details class="mb-4">
            <summary
              class="px-4 py-2 font-semibold bg-gray-200 rounded-md"
            >How can I migrate to another site?</summary>

            <span>
              Laboris qui labore cillum culpa in sunt quis sint veniam. Dolore ex aute
              deserunt esse ipsum elit aliqua. Aute quis minim velit nostrud pariatur culpa
              magna in aute.
            </span>
          </details>
        </div>
        <div class="w-full px-4 py-2 lg:w-1/2">
          <details class="mb-4">
            <summary
              class="px-4 py-2 font-semibold bg-gray-200 rounded-md"
            >Can I change the domain you give me?</summary>

            <span class="px-4 py-2">
              Laboris qui labore cillum culpa in sunt quis sint veniam. Dolore ex aute
              deserunt esse ipsum elit aliqua. Aute quis minim velit nostrud pariatur culpa
              magna in aute.
            </span>
          </details>
          <details class="mb-4">
            <summary
              class="px-4 py-2 font-semibold bg-gray-200 rounded-md"
            >How many sites I can create at once?</summary>

            <span class="px-4 py-2">
              Laboris qui labore cillum culpa in sunt quis sint veniam. Dolore ex aute
              deserunt esse ipsum elit aliqua. Aute quis minim velit nostrud pariatur culpa
              magna in aute.
            </span>
          </details>
          <details class="mb-4">
            <summary
              class="px-4 py-2 font-semibold bg-gray-200 rounded-md"
            >How can I communicate with you?</summary>

            <span class="px-4 py-2">
              Laboris qui labore cillum culpa in sunt quis sint veniam. Dolore ex aute
              deserunt esse ipsum elit aliqua. Aute quis minim velit nostrud pariatur culpa
              magna in aute.
            </span>
          </details>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Faq",
};
</script>

<style scoped>
</style>
